
<div class="container">
  <div class="back-button" v-if="backButton" @click="$emit('back')">
    <div class="icon-button">
      <n-icon icon="arrow-left" size="s" />
    </div>
    <div>{{ backButtonLabel }}</div>
  </div>
  <div
    class="title-row"
    :class="{
      'with-back-button': backButton,
      'has-subtitle': !!subtitle,
      'with-close-button': closable,
      m: titleSize === 'm'
    }"
  >
    <div class="titlebar-title">{{ title }}</div>
    <span v-if="titleSuffix" class="beta-element">{{ titleSuffix }}</span>
  </div>
  <div class="subtitle" v-if="subtitle">{{ subtitle }}</div>
  <div v-if="showMenu" class="menu-button" ref="menuButton" @click="$emit('openMenu', $refs.menuButton)">
    <div class="icon-button">
      <n-icon icon="dots-horizontal" size="s" />
    </div>
  </div>
  <div class="close-button">
    <button
      v-if="closable"
      type="button"
      class="icon-button"
      :aria-label="$t('general.close')"
      @click="$emit('close')"
    >
      <n-icon icon="x" size="s" />
    </button>
  </div>
</div>
